module.exports = __webpack_public_path__ + "media/assets/images/smart_working/7-4-s-b11c1732c83d456de06c37bb3362b28d.jpg";